import { Controller } from "@hotwired/stimulus"

// Auto-scrolls chat messages container to bottom on new messages.
// Uses MutationObserver to detect DOM changes from Turbo Stream broadcasts.
export default class extends Controller {
  static targets = ["messagesContainer"]

  connect() {
    this.initialScroll = true
    this.scrollToBottom()

    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })

    if (this.hasMessagesContainerTarget) {
      this.observer.observe(this.messagesContainerTarget, {
        childList: true,
        subtree: true,
        characterData: true
      })
    }

    this.onMessageSubmitted = () => {
      this.forceNextScroll = true
      this.scrollToBottom()
    }
    document.addEventListener("chat:message-submitted", this.onMessageSubmitted)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    document.removeEventListener("chat:message-submitted", this.onMessageSubmitted)
  }

  scrollToBottom() {
    const container = this.hasMessagesContainerTarget
      ? this.messagesContainerTarget
      : this.element

    // Only auto-scroll if user is near the bottom, on initial load, or after sending a message
    const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 100
    if (!isNearBottom && !this.initialScroll && !this.forceNextScroll) return

    requestAnimationFrame(() => {
      container.scrollTop = container.scrollHeight
      this.initialScroll = false
      this.forceNextScroll = false
    })
  }
}
